var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionCard"},[_vm._v(" "+_vm._s(_vm.question.question)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }